import styled from 'styled-components/macro';
import Colors from '../../../internal-components/Colors';

const OTGreyCard = styled.div`
  width: 100%;
  background: ${Colors.BACKGROUND_GREY};
  padding: 0.8rem;
  ${({ $rounded }) => $rounded && 'border-radius: 6px;'}
  ${({ $css }) => $css};
`;

export default OTGreyCard;
